import { IApiResponse } from 'types'
import {
  PATIENT_LIST,
  SEARCH_PATIENT_BY_CPF,
  PATIENT_PROFESSIONAL_RELATION,
  PATIENT_CALCULATIONS,
  PATIENT_VITAL_SIGNS,
  PATIENT_REGISTRATION,
  PATIENT_HISTORICAL_VALUES,
  PATIENT_MEDICAL_INFO,
  PATIENT_REGISTRATION_BASE
} from './CONSTANTS'
import { request } from 'services/base'
import {
  HistoricalValuesPeriodTypes,
  IPatientCalculationsResponse,
  IPatientProfessionalRelationRequest,
  IPatientHistoricalValuesResponse,
  IPatientMedicalInfoResponse,
  IPatientResponse,
  IPatientVitalSignsPatch,
  IPatientVitalSignsResponse,
  IPatientRequest,
  IPatientFormRequest
} from 'types/patient/types'

export const getPatientList = async (
  professionalId: string
): Promise<IApiResponse<IPatientResponse[]>> =>
  await request({ url: PATIENT_LIST(professionalId), method: 'get' })

export const searchPatientsByCPF = async (
  cpf: string
): Promise<IApiResponse<IPatientResponse>> =>
  await request({ url: SEARCH_PATIENT_BY_CPF(cpf), method: 'get' })

export const postPatientProfessionalRelation = async (
  data: IPatientProfessionalRelationRequest
): Promise<IApiResponse<object>> =>
  await request({ url: PATIENT_PROFESSIONAL_RELATION, method: 'post', data })

export const getPatientCalculations = async (
  patientId: string
): Promise<IApiResponse<IPatientCalculationsResponse>> =>
  await request({ url: PATIENT_CALCULATIONS(patientId), method: 'get' })

export const getPatientVitalSigns = async (
  patientId: string
): Promise<IApiResponse<IPatientVitalSignsResponse>> =>
  await request({ url: PATIENT_VITAL_SIGNS(patientId), method: 'get' })

export const getPatientRegistration = async (
  patientId: string
): Promise<IApiResponse<IPatientResponse>> =>
  await request({ url: PATIENT_REGISTRATION(patientId), method: 'get' })

export const postPatientRegistration = async (
  data: IPatientFormRequest,
  establishmentId: string
): Promise<IApiResponse<IPatientResponse>> =>
  await request({
    url: PATIENT_REGISTRATION_BASE,
    method: 'post',
    data,
    headers: {
      establishment: establishmentId
    }
  })

export const getPatientMedicalInfo = async (
  patientId: string
): Promise<IApiResponse<IPatientMedicalInfoResponse>> =>
  await request({ url: PATIENT_MEDICAL_INFO(patientId), method: 'get' })

export const getPatientHistoricalValues = async (
  patientId: string,
  dataType: string,
  period: HistoricalValuesPeriodTypes,
  referenceDate?: Date
): Promise<IApiResponse<IPatientHistoricalValuesResponse>> =>
  await request({
    url: PATIENT_HISTORICAL_VALUES(patientId, dataType, period),
    method: 'get',
    params: {
      reference_date: referenceDate?.toISOString()
    }
  })

export const patchtPatientMedicalInfo = async (
  patientId: string,
  data: IPatientMedicalInfoResponse
): Promise<IApiResponse<any>> =>
  await request({ url: PATIENT_MEDICAL_INFO(patientId), method: 'patch', data })

export const patchPatientVitalSigns = async (
  patientId: string,
  data?: IPatientVitalSignsPatch
): Promise<IApiResponse<any>> =>
  await request({ url: PATIENT_VITAL_SIGNS(patientId), method: 'patch', data })
